export default {
  namespaced: true,
  state () {
    return {
      customerId: "",
    }
  },
  actions: {
    updateCustomer (context, payload) {
      context.commit("updateCustomer", payload)
    },
  },
  getters: {
    getCustomerId (state) {
      return state.customerId
    },
  },
  mutations: {
    updateCustomer (state, payload) {
      state.customerId = payload
    },
  },
}
